<mat-card class="question-card center">
  <mat-card-content>
    <mat-label class="mat-title question-text">{{title}}</mat-label>
    <div *ngIf="text">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
        </mat-expansion-panel-header>       
        <p>{{text}}</p>       
      </mat-expansion-panel>
    </div>
    <div *ngIf="ctrl">
      <mat-error *ngIf="invalid">
        <div *ngIf="ctrl.errors.required" [innerHTML]="requiredErrorMessage"></div>
        <div *ngIf="!ctrl.errors.required && !ctrl.errors.pattern && ctrl.errors.minDate" [innerHTML]="minDateErrorMessage"></div>
        <div *ngIf="!ctrl.errors.required && !ctrl.errors.pattern && ctrl.errors.maxDate" [innerHTML]="maxDateErrorMessage"></div>
        <div *ngIf="!ctrl.errors.required && ctrl.errors.pattern" [innerHTML]="patternErrorMessage"></div>
      </mat-error>
    </div>
    <br />
    <div [formGroup]="form">
      <div class="form-control">
        <mat-form-field *ngIf="ctrl">
          <input matInput readonly="true" [matDatepicker]="picker" id="{{question.name}}" autocomplete="off" placeholder="{{question.title}}" [formControl]="ctrl" (click)="openPicker($event)" class="full-width">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker startView="multi-year" (monthSelected)="chosenMonthHandler($event)"></mat-datepicker>
        </mat-form-field>
      </div>
    </div>
  </mat-card-content>
</mat-card>
